import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { UserPreferencesComponent } from './user-preferences.component';
import { NotificationSoundComponent } from './notification-sound/notification-sound.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';

@NgModule({
  declarations: [UserPreferencesComponent, NotificationSoundComponent, AudioPlayerComponent],
  imports: [
    MatProgressSpinnerModule,
    SharedModule,
    RouterModule,
  ],
  exports: [UserPreferencesComponent, NotificationSoundComponent, AudioPlayerComponent],
  
})
export class UserPreferencesModule { }
